module.exports = __webpack_public_path__ + "img/jiangbei.85edeae0.png";